import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { noop, addClassName, removeClassName } from './utils';
var INVALID_VALUE = null; // copied from https://github.com/mzabriskie/react-draggable/blob/master/lib/utils/domFns.js

export function addUserSelectStyles(doc) {
  if (!doc) return;
  var styleEl = doc.getElementById('react-draggable-style-el');

  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = 'react-draggable-style-el';
    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
    doc.getElementsByTagName('head')[0].appendChild(styleEl);
  }

  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}
export function removeUserSelectStyles(doc) {
  if (!doc) return;

  try {
    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');

    if (doc.selection) {
      doc.selection.empty();
    } else {
      // Remove selection caused by scroll, unless it's a focused input
      // (we use doc.defaultView in case we're in an iframe)
      var selection = (doc.defaultView || window).getSelection();

      if (selection && selection.type !== 'Caret') {
        selection.removeAllRanges();
      }
    }
  } catch (e) {// probably IE
  }
}
var eventsFor = {
  touch: {
    start: 'touchstart',
    move: 'touchmove',
    stop: 'touchend'
  },
  mouse: {
    start: 'mousedown',
    move: 'mousemove',
    stop: 'mouseup'
  }
};
var dragEventFor = eventsFor.mouse;
/**
 * ColumnResizer for BaseTable
 */

var ColumnResizer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(ColumnResizer, _React$PureComponent);

  function ColumnResizer(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.isDragging = false;
    _this.lastX = INVALID_VALUE;
    _this.width = 0;
    _this._setHandleRef = _this._setHandleRef.bind(_assertThisInitialized(_this));
    _this._handleClick = _this._handleClick.bind(_assertThisInitialized(_this));
    _this._handleMouseDown = _this._handleMouseDown.bind(_assertThisInitialized(_this));
    _this._handleMouseUp = _this._handleMouseUp.bind(_assertThisInitialized(_this));
    _this._handleTouchStart = _this._handleTouchStart.bind(_assertThisInitialized(_this));
    _this._handleTouchEnd = _this._handleTouchEnd.bind(_assertThisInitialized(_this));
    _this._handleDragStart = _this._handleDragStart.bind(_assertThisInitialized(_this));
    _this._handleDragStop = _this._handleDragStop.bind(_assertThisInitialized(_this));
    _this._handleDrag = _this._handleDrag.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ColumnResizer.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.handleRef) {
      var ownerDocument = this.handleRef.ownerDocument;
      ownerDocument.removeEventListener(eventsFor.mouse.move, this._handleDrag);
      ownerDocument.removeEventListener(eventsFor.mouse.stop, this._handleDragStop);
      ownerDocument.removeEventListener(eventsFor.touch.move, this._handleDrag);
      ownerDocument.removeEventListener(eventsFor.touch.stop, this._handleDragStop);
      removeUserSelectStyles(ownerDocument);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        style = _this$props.style,
        column = _this$props.column,
        onResizeStart = _this$props.onResizeStart,
        onResize = _this$props.onResize,
        onResizeStop = _this$props.onResizeStop,
        minWidth = _this$props.minWidth,
        rest = _objectWithoutPropertiesLoose(_this$props, ["style", "column", "onResizeStart", "onResize", "onResizeStop", "minWidth"]);

    return React.createElement("div", _extends({}, rest, {
      ref: this._setHandleRef,
      onClick: this._handleClick,
      onMouseDown: this._handleMouseDown,
      onMouseUp: this._handleMouseUp,
      onTouchStart: this._handleTouchStart,
      onTouchEnd: this._handleTouchEnd,
      style: _objectSpread({
        userSelect: 'none',
        touchAction: 'none',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        cursor: 'col-resize'
      }, style)
    }));
  };

  _proto._setHandleRef = function _setHandleRef(ref) {
    this.handleRef = ref;
  };

  _proto._handleClick = function _handleClick(e) {
    e.stopPropagation();
  };

  _proto._handleMouseDown = function _handleMouseDown(e) {
    dragEventFor = eventsFor.mouse;

    this._handleDragStart(e);
  };

  _proto._handleMouseUp = function _handleMouseUp(e) {
    dragEventFor = eventsFor.mouse;

    this._handleDragStop(e);
  };

  _proto._handleTouchStart = function _handleTouchStart(e) {
    dragEventFor = eventsFor.touch;

    this._handleDragStart(e);
  };

  _proto._handleTouchEnd = function _handleTouchEnd(e) {
    dragEventFor = eventsFor.touch;

    this._handleDragStop(e);
  };

  _proto._handleDragStart = function _handleDragStart(e) {
    if (typeof e.button === 'number' && e.button !== 0) return;
    this.isDragging = true;
    this.lastX = INVALID_VALUE;
    this.width = this.props.column.width;
    this.props.onResizeStart(this.props.column);
    var ownerDocument = this.handleRef.ownerDocument;
    addUserSelectStyles(ownerDocument);
    ownerDocument.addEventListener(dragEventFor.move, this._handleDrag);
    ownerDocument.addEventListener(dragEventFor.stop, this._handleDragStop);
  };

  _proto._handleDragStop = function _handleDragStop(e) {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.props.onResizeStop(this.props.column);
    var ownerDocument = this.handleRef.ownerDocument;
    removeUserSelectStyles(ownerDocument);
    ownerDocument.removeEventListener(dragEventFor.move, this._handleDrag);
    ownerDocument.removeEventListener(dragEventFor.stop, this._handleDragStop);
  };

  _proto._handleDrag = function _handleDrag(e) {
    var clientX = e.clientX;

    if (e.type === eventsFor.touch.move) {
      e.preventDefault();
      if (e.targetTouches && e.targetTouches[0]) clientX = e.targetTouches[0].clientX;
    }

    var offsetParent = this.handleRef.offsetParent;
    var offsetParentRect = offsetParent.getBoundingClientRect();
    var x = clientX + offsetParent.scrollLeft - offsetParentRect.left;

    if (this.lastX === INVALID_VALUE) {
      this.lastX = x;
      return;
    }

    var _this$props2 = this.props,
        column = _this$props2.column,
        MIN_WIDTH = _this$props2.minWidth;
    var width = column.width,
        maxWidth = column.maxWidth,
        _column$minWidth = column.minWidth,
        minWidth = _column$minWidth === void 0 ? MIN_WIDTH : _column$minWidth;
    var movedX = x - this.lastX;
    if (!movedX) return;
    this.width = this.width + movedX;
    this.lastX = x;
    var newWidth = this.width;

    if (maxWidth && newWidth > maxWidth) {
      newWidth = maxWidth;
    } else if (newWidth < minWidth) {
      newWidth = minWidth;
    }

    if (newWidth === width) return;
    this.props.onResize(column, newWidth);
  };

  return ColumnResizer;
}(React.PureComponent);

ColumnResizer.defaultProps = {
  onResizeStart: noop,
  onResize: noop,
  onResizeStop: noop,
  minWidth: 30
};
ColumnResizer.propTypes = {
  /**
   * Custom style for the drag handler
   */
  style: PropTypes.object,

  /**
   * The column object to be dragged
   */
  column: PropTypes.object,

  /**
   * A callback function when resizing started
   * The callback is of the shape of `(column) => *`
   */
  onResizeStart: PropTypes.func,

  /**
   * A callback function when resizing the column
   * The callback is of the shape of `(column, width) => *`
   */
  onResize: PropTypes.func,

  /**
   * A callback function when resizing stopped
   * The callback is of the shape of `(column) => *`
   */
  onResizeStop: PropTypes.func,

  /**
   * Minimum width of the column could be resized to if the column's `minWidth` is not set
   */
  minWidth: PropTypes.number
};
export default ColumnResizer;
//# sourceMappingURL=ColumnResizer.js.map